import { ca } from '@cian/analytics';

import { getCustomUrl } from './getCustomUrl';
import { getTrackingProducts } from './getTrackingProducts';

export const trackShowPhoneClick = (builderId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_builder_contact_block_head',
    label: getCustomUrl(builderId),
    products: getTrackingProducts(builderId),
  });
};
